import { create } from 'zustand';

/**
 * Whether the keyboard shortcut list is open (spec 129 FR-013). Shared so the
 * account menu, the palette and the `?` key all open the same sheet.
 */
export const useShortcutSheetStore = create<{
  open: boolean;
  setOpen: (open: boolean) => void;
}>((set) => ({
  open: false,
  setOpen: (open) => {
    set({ open });
  },
}));
